import {Component} from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  ActionSheetController,
  ViewController,
  ToastController,
  ModalController
} from 'ionic-angular';
import { ClubProvider } from '../../../providers/club/club';
import {TranslateService} from "@ngx-translate/core";
import {ImageEdit} from "../new-post/image-edit/image-edit";

/**
 * Generated class for the CreateClubSponsorshipPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-create-club-sponsorship',
  templateUrl: 'create-club-sponsorship.html',
})
export class CreateClubSponsorshipPage {
  clubInfos:any = {
    avatar: '',
    name: '',
    description : '',
    city: 'Lyon',
    active: true,
    sponsored: true,
    budget: 0,
    frequency: 1,
    memberPrediction: 0
  }

  radioLabels = [
    this.translate.instant('create-club-sponsorship.-1x/m'),
    this.translate.instant('create-club-sponsorship.1x/m'),
    this.translate.instant('create-club-sponsorship.+1x/m')
  ];

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public actionSheetCtrl: ActionSheetController,
    public clubProvider: ClubProvider,
    public toastCtrl: ToastController,
    private translate: TranslateService,
    private modalCtrl: ModalController) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CreateClubSponsorshipPage');
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }



  createClub(){
  this.clubProvider.create(this.clubInfos).subscribe((res) => {
    if(res.success){
      let toast = this.toastCtrl.create({
        message: 'Vous avez créé le club '+this.clubInfos.name,
        duration: 3000,
        position: 'top'
      });
      toast.present();
      this.clubProvider.join(res.data.id).subscribe((res) => {
        if(res.success){
          this.viewCtrl.dismiss();
        }
      })
    }else {
      console.log('failed');
    }
  })
}


  handleFileSelect(evt){
    var files = evt.target.files;
    var file = files[0];

    this.presentModal(file);
  }


  presentModal(file) {
    const modal = this.modalCtrl.create(ImageEdit, {file: file});
    modal.onDidDismiss(res => {
      if(res?.image) {
        this.clubInfos.avatar = res.image;
      }
    });
    modal.present().then(() => {});
  }

}



// WEBPACK FOOTER //
// ./src/pages/employee/create-club-sponsorship/create-club-sponsorship.ts